<template>
  <div class="login">
    <div class="header clearfix">
      <router-link class="fl" to="/index"
        ><img src="~@/assets/imgs/Group10.png" alt="logo"
      /></router-link>
      <router-link class="fr" to="/index">返回网站首页>></router-link>
    </div>
    <div class="content">
      <div class="content_login">
        <p v-show="forgetFlag == 0" class="title">
          <span>个人用户-忘记密码</span>
        </p>
        <p v-show="forgetFlag == 1" class="title">
          <span>单位用户-忘记密码</span>
        </p>
        <div class="msg">
          <label
            ><input
              v-show="forgetFlag == 0"
              placeholder="请输入常用注册手机号"
              v-model="tel"
              type="text" /><img
              style="top: 22px"
              src="~@/assets/imgs/email.png"
              alt="科研人才网-事业单位硕士博士人才招聘"
          /></label>
          <label
            ><input
              v-show="forgetFlag == 1"
              placeholder="请输入常用注册邮箱"
              v-model="email"
              type="text" /><img
              style="top: 22px"
              src="~@/assets/imgs/email.png"
              alt="科研人才网-硕士博士人才招聘"
          /></label>
          <label
            ><input
              placeholder="请输入证码"
              maxlength="6"
              @blur="checkverCode()"
              v-model="verCode"
              type="text" /><img
              style="top: 22px"
              src="~@/assets/imgs/email.png"
              alt="科研人才网-事业单位硕士博士人才招聘"
          /></label>
          <span class="msCode" @click="sendMsg">{{ sendMessage }}</span>
          <label
            ><input
              placeholder="请输入登陆密码"
              v-model="cPassword"
              type="password" /><img src="~@/assets/imgs/password.png" alt=""
          /></label>
          <label
            ><input
              placeholder="请确认登陆密码"
              v-model="recPassword"
              @blur="checkcomPsw"
              type="password" /><img src="~@/assets/imgs/password.png" alt=""
          /></label>
          <span class="loginBtn" @click="companyRegister">修改密码</span>
          <p class="clearfix forget" v-show="forgetFlag == 0">
            <i class="fl register" @click="toLogin(true)"
              >已有账号：<span
                >直接登陆<img src="~@/assets/imgs/shape.png" alt="" /></span
            ></i>
            <span class="fr forgetPassword" @click="forgetFlag = 1"
              >去招聘</span
            >
          </p>
          <p class="clearfix forget" v-show="forgetFlag == 1">
            <i class="fl register" @click="toLogin(false)"
              >已有账号：<span
                >直接登陆<img src="~@/assets/imgs/shape.png" alt="" /></span
            ></i>
            <span class="fr forgetPassword" @click="forgetFlag = 0"
              >找工作</span
            >
          </p>
          <p class="protocol">
            注册邮箱即为接收投递简历邮箱，注册代表你已同意<router-link to=""
              >《科研 人才网协议》</router-link
            >
          </p>
        </div>
      </div>
    </div>
    <div class="footer clearfix">
      <div class="models fl clearfix">
        <img class="fl" src="~@/assets/imgs/strong.png" alt="" />
        <h3>强大的招聘平台</h3>
        <p>提供快捷、高效、可靠的网上招聘</p>
      </div>
      <div class="models fl clearfix">
        <img class="fl" src="~@/assets/imgs/opportunity.png" alt="" />
        <h3>强大的招聘平台</h3>
        <p>提供快捷、高效、可靠的网上招聘</p>
      </div>
      <div class="models fl clearfix">
        <img class="fl" src="~@/assets/imgs/Group.png" alt="" />
        <h3>强大的招聘平台</h3>
        <p>提供快捷、高效、可靠的网上招聘</p>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>
import { get, postWithJson, form } from "@/api/services";
import AppFooter from "../../components/common/footer.vue";
import AppHeader from "../../components/common/header1.vue";
export default {
  name: "companyForget",
  components: { AppFooter },
  data() {
    return {
      forgetFlag: 0,
      tel: "", //手机号
      email: "", //邮箱
      verCode: "", //短信验证码
      cPassword: "", //密码
      recPassword: "", //再次输入密码
      sendMsgFlag: true, //发送短信验证码
      nums: 60, //倒计时
      sendMessage: "获取验证码",
    };
  },
  created: function () {
    this.forgetFlag =
      this.$route.query.jId == undefined ? 0 : this.$route.query.jId;
  },
  methods: {
    toLogin(flags) {
      this.$router.push({ path: "/login", query: { loginFlag: flags } });
    },
    checkverCode() {
      let _self = this;
      if (_self.verCode == "") {
        return false;
      }
      if (_self.verCode.length != 6) {
        this.$message({
          message: "验证码长度有误",
          type: "warning",
        });
      }
    },
    checkcomPsw() {
      let _self = this;
      if (_self.cPassword != _self.recPassword) {
        this.$message({
          message: "密码输入不一致,请重新输入！",
          type: "warning",
        });
      }
    },
    sendMsg() {
      let _self = this,
        reqData = "";
      if (this.forgetFlag == 1) {
        let myreg =
          /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        console.log(_self.email);
        if (!myreg.test(_self.email)) {
          this.$message({
            message: "请输入正确的邮箱地址！",
            type: "warning",
          });
          return false;
        } else {
          reqData = {
            userType: 2,
            receiveMan: this.email + "",
          };
        }
      } else if (this.forgetFlag == 0) {
        let myreg = /^1\d{10}$/;
        if (!myreg.test(_self.tel)) {
          this.$message({
            message: "请输入正确的手机号！",
            type: "warning",
          });
          return false;
        } else {
          reqData = {
            userType: 3,
            receiveMan: this.tel + "",
          };
        }
      }
      if (!_self.sendMsgFlag) {
        this.$message({
          message: "请" + _self.nums + "秒后重试",
          type: "warning",
        });
        return false;
      }
      postWithJson("front/sms/sendSms", reqData).then(
        function (response) {
          if (response.data.status) {
            _self.sendMsgFlag = false;
            _self.$message({
              message: "验证码发送成功，请检查并填写验证码！",
              type: "success",
            });
            var timer = setInterval(function () {
              _self.nums--;
              _self.sendMessage = _self.nums + "秒后重试";
              if (_self.nums <= 0) {
                clearInterval(timer);
                _self.sendMsgFlag = true;
                _self.nums = 60;
                _self.sendMessage = "获取验证码";
              }
            }, 1000);
          } else {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
          }
        },
        function (response) {
          _self.$message({
            message: response.data.message,
            type: "error",
          });
        }
      );
    },
    companyRegister() {
      let _self = this;
      let reqDatas = "",
        reqDatas1 = "";
      if (this.verCode == "") {
        this.$message({
          message: "请输入正确验证码！",
          type: "warning",
        });
        return false;
      }
      if (_self.forgetFlag == 0) {
        reqDatas1 = {
          receiveMan: _self.tel,
          verifyCode: _self.verCode,
        };
        reqDatas = {
          userType: 1,
          receiveMan: _self.tel,
          newPassWord: _self.recPassword,
        };
      } else if (_self.forgetFlag == 1) {
        reqDatas1 = {
          receiveMan: _self.email,
          verifyCode: _self.verCode,
        };
        reqDatas = {
          userType: 2,
          receiveMan: _self.email,
          newPassWord: _self.recPassword,
        };
      }
      if (this.cPassword == "") {
        this.$message({
          message: "请输入登陆密码！",
          type: "warning",
        });
        return false;
      }
      if (this.recPassword == "") {
        _self.$message({
          message: "请再次输入登陆密码！",
          type: "warning",
        });
        return false;
      }
      if (_self.forgetFlag == 0) {
        let myreg = /^1\d{10}$/;
        if (!myreg.test(_self.tel)) {
          _self.$message({
            message: "请输入正确的手机号！",
            type: "warning",
          });
          return false;
        }
      } else if (_self.forgetFlag == 1) {
        let myreg =
          /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
        console.log(_self.email);
        if (!myreg.test(_self.email)) {
          _self.$message({
            message: "请输入正确的邮箱地址！",
            type: "warning",
          });
          return false;
        }
      }

      new Promise((resolve, reject) => {
        postWithJson("front/sms/checkSms", reqDatas1).then(
          function (response) {
            if (response.data.status) {
              resolve();
            } else {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
              return false;
            }
          },
          function (response) {
            _self.$message({
              message: response.data.message,
              type: "error",
            });
            return false;
          }
        );
      }).then((result) => {
        return new Promise((resolve, reject) => {
          postWithJson("front/user/updatePassWord", reqDatas).then(
            function (response) {
              if (response.data.status) {
                _self.$message({
                  message: "修改成功，请登陆",
                  type: "success",
                });
                _self.$router.push({
                  path: "/login",
                  query: { loginFlag: true },
                });
              } else {
                _self.$message({
                  message: response.data.message,
                  type: "error",
                });
              }
            },
            function (response) {
              _self.$message({
                message: response.data.message,
                type: "error",
              });
              return false;
            }
          );
        });
      });
    },
  },
};
</script>
<style scoped = "scoped"  lang = "less">
.login {
  background-color: white;
  .header {
    width: 1200px;
    margin: 0 auto;
    height: 105px;
    line-height: 105px;
    .fl {
      margin-top: 24px;
    }
    .fr {
      font-size: 16px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(23, 135, 251, 1);
    }
  }
  .content {
    width: 100%;
    height: 530px;
    background: url("~@/assets/imgs/loginBg.png") no-repeat center center;
    position: relative;
    .content_login {
      background-color: white;
      width: 390px;
      height: 510px;
      position: absolute;
      top: 10px;
      left: 50%;
      margin-left: 180px;
      padding: 30px 35px 35px;
      .title {
        color: #1787fb;
        span {
          display: inline-block;
          width: 100%;
          text-align: center;
          font-size: 20px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          cursor: pointer;
        }
      }
      .msg {
        position: relative;
        label {
          display: block;
          position: relative;
          margin-top: 20px;
          input {
            width: 100%;
            height: 50px;
            text-indent: 40px;
          }
          img {
            position: absolute;
            left: 14px;
            top: 17px;
          }
        }
        .loginBtn {
          display: inline-block;
          width: 100%;
          height: 46px;
          line-height: 46px;
          text-align: center;
          color: white;
          background-color: #1787fb;
          border-radius: 4px;
          margin-top: 20px;
          cursor: pointer;
          font-size: 20px;
          letter-spacing: 4px;
        }

        .forget {
          margin-top: 20px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          .register {
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #333;
            height: 36px;
            overflow: hidden;
            font-style: normal;
            span {
              height: 34px;
              line-height: 34px;
              display: inline-block;
              width: 110px;
              margin-left: 4px;
              vertical-align: middle;
              border: 1px solid #1787fb;
              cursor: pointer;
              border-radius: 4px;
              text-align: center;
              color: #1787fb;
              box-sizing: border-box;
              img {
                vertical-align: middle;
                margin-left: 4px;
                margin-top: -2px;
              }
            }
          }
          .forgetPassword {
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            color: #1787fb;
            cursor: pointer;
          }
        }
        .msCode {
          position: absolute;
          display: inline-block;
          height: 50px;
          line-height: 50px;
          padding: 0 20px;
          top: 70px;
          right: 0px;
          font-size: 14px;
          font-family: Helvetica;
          color: rgba(23, 135, 251, 1);
          cursor: pointer;
        }
        .protocol {
          font-size: 12px;
          font-family: PingFangSC-Semibold;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          line-height: 14px;
          margin-top: 18px;
          a {
            color: #1787fb;
          }
        }
      }
    }
  }
  .footer {
    width: 1200px;
    margin: 60px auto 80px;
    .models {
      width: 33.3%;
      height: 58px;
      img {
        height: 58px;
        margin-right: 10px;
      }
      h3 {
        height: 25px;
        font-size: 18px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 25px;
      }
      p {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 20px;
        margin-top: 10px;
      }
    }
  }
}
@media all and (max-width: 768px) {
  .login {
    .header {
      width: 100%;
    }
    .content {
      .content_login {
        width: 80%;
        left: 0;
        margin-left: 10%;
        height: 514px;
      }
    }
    .footer {
      width: 100%;
      margin: 30px auto 30px;
      .models {
        width: 100%;
        margin-top: 16px;
        padding-left: 20px;
      }
    }
    .footerBottom {
      .footer_top {
        height: 76px;
        line-height: 36px;
      }
      .footer_bottom {
        height: 250px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/forget.vue